<div>
  @if (loading) {
    <div class="h-100 d-flex justify-content-center align-items-center loading-data">
      <app-spinner></app-spinner>
    </div>
  }
  @if (series?.length === 0 && !loading) {
    <div
      class="text-primary font-weight-bold d-flex justify-content-center align-items-center w-100 no-data"
      >
      {{'DATA_STUDIO.PREVIEW.NO_DATA' | translate}}
    </div>
  }
  @if (series?.length > 0 && !loading) {
    <highcharts-chart
      class="w-100 d-block"
      [Highcharts]="highcharts"
      [options]="chartOptions"
      [callbackFunction]="chartCallback">
    </highcharts-chart>
  }
</div>
